import { ApiService } from "./ApiService"

export class LogisticMovementService {

    static uri = '/logistic/movements';

    static get({ params }) {
        return ApiService.get(`${this.uri}`, {
            params,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }

    static store({ data }) {
        return ApiService.post(`${this.uri}`, data, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token-radiustrend')}`,
            },
        });
    }
}